// Note that we can't use destructuring assignment here, because VITE will
// replace these at compile time.
// Allow local storage env can override the environment variables
const localStorageEnv = localStorage.getItem('PERSISTENT_env');
const mode = localStorageEnv ?? import.meta.env.MODE;

const validLowerEnvironments = ['staging', 'dev', 'test'];
const prod = localStorageEnv
  ? !validLowerEnvironments.includes(localStorageEnv)
  : !!import.meta.env.PROD;

export const IS_PRODUCTION = prod;
// Make permanently false to prevent users from switching to integration environment
export const IS_DEV = !prod && mode === 'dev';
export const IS_STAGING = !prod && mode === 'staging';
export const IS_TEST = !prod && mode === 'test';
export const IS_LOWER_ENVIRONMENT = !IS_PRODUCTION && validLowerEnvironments.includes(mode);

if (!IS_PRODUCTION && !IS_DEV && !IS_STAGING && !IS_TEST) {
  console.error(`Environment variable not set correctly. Current value: ${mode}`);
}

export const env = {
  PROD: prod,
  MODE: mode,
};
